<template>
  <div id="one_view_form">
    <div class="text-center no-print" style="margin: 20px 0;">
      <button class="print-btn" @click="printForm()">Print Profile</button>
    </div>

    <div class="form-wrapper">
      <div class="print-page">

        <table class="header-table">
          <tr>
            <td class="header-logo-cell">
              <img
                v-if="org_basic_data && org_basic_data.school_logo"
                :src="org_basic_data.school_logo"
                alt="logo"
                class="college-logo"
              />
              <div v-else class="logo-placeholder">Logo</div>
            </td>
            <td class="header-info-cell">
              <h1 class="college-name">{{ org_basic_data ? org_basic_data.school_name : '' }}</h1>
              <div class="college-address"><b>{{ org_basic_data ? org_basic_data.address : '' }}</b></div>
            </td>
            <td class="header-photo-cell">
              <img
                v-if="learner_photo"
                :src="awspath + learner_photo"
                alt="Student Photo"
                class="student-photo"
              />
              <div v-else class="photo-placeholder">Photo</div>
            </td>
          </tr>
        </table>

        <div class="section-block mt-2">
          <div class="section-title">Basic Details</div>
          <table class="form-table">
            <colgroup>
                <col style="width:20%" />
                <col style="width:30%" />
                <col style="width:20%" />
                <col style="width:30%" />
            </colgroup>

            <tr>
                <td class="label-cell">Name of the Student</td>
                <td class="value-cell text-center">{{ studentMap.last_name || '' }}</td>
                <td class="value-cell text-center">{{ studentMap.first_name || '' }}</td>
                <td class="value-cell text-center">{{ studentMap.middle_name || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell"></td>
                <td class="sub-label"><b>Surname</b></td>
                <td class="sub-label"><b>First Name</b></td>
                <td class="sub-label"><b>Father's Name</b></td>
            </tr>

            <tr>
                <td class="label-cell">Name as per Aadhar</td>
                <td class="value-cell">{{ studentMap.name_as_per_aadhar || '' }}</td>
                <td class="label-cell">Gender</td>
                <td class="value-cell">{{ studentMap.gender || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">Registration Number</td>
                <td class="value-cell">{{ studentMap.registration_no || '' }}</td>
                <td class="label-cell">Blood Group</td>
                <td class="value-cell">{{ studentMap.blood_group || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">Date of Birth</td>
                <td class="value-cell">{{ studentMap.date_of_birth || '' }}</td>
                <td class="label-cell">Date of Birth in Words</td>
                <td class="value-cell">{{ studentMap.date_of_birth_in_words || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">GR No.</td>
                <td class="value-cell">{{ studentMap.gr_no || '' }}</td>
                <td class="label-cell">PEN No.</td>
                <td class="value-cell">{{ studentMap.pen || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">Saral ID</td>
                <td class="value-cell">{{ studentMap.saral_id || '' }}</td>
                <td class="label-cell">APAAR ID</td>
                <td class="value-cell">{{ studentMap.apaar_id || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">Birth Place</td>
                <td class="value-cell">{{ studentMap.birth_place || '' }}</td>
                <td class="label-cell">Nationality</td>
                <td class="value-cell">{{ studentMap.nationality || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">Standard</td>
                <td class="value-cell">{{ studentMap.standard || '' }}</td>
                <td class="label-cell">Division</td>
                <td class="value-cell">{{ studentMap.division || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">Roll No.</td>
                <td class="value-cell">{{ studentMap.roll_no || '' }}</td>
                <td class="label-cell">School Medium</td>
                <td class="value-cell">{{ studentMap.school_medium || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">House</td>
                <td class="value-cell">{{ studentMap.house || '' }}</td>
                <td class="label-cell">Date of Admission</td>
                <td class="value-cell">{{ studentMap.date_of_admission || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">Date of Physically Attended</td>
                <td class="value-cell">{{ studentMap.date_of_physically_attended || '' }}</td>
                <td class="label-cell">Is Physically Disabled</td>
                <td class="value-cell">
                    {{ PhysicallyChallenged && PhysicallyChallenged.is_physically_disabled && PhysicallyChallenged.is_physically_disabled.value ? 'Yes' : 'No' }}
                </td>
            </tr>

            <tr>
                <td class="label-cell">Aadhar No.</td>
                <td class="value-cell">{{ studentMap.aadhar_no || '' }}</td>
                <td class="label-cell">Family Income (Rs.)</td>
                <td class="value-cell">{{ studentMap.family_income_in_rs || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">Birth Address</td>
                <td class="value-cell">{{ birthMap.birth_address || '' }}</td>
                <td class="label-cell">Birth Taluka</td>
                <td class="value-cell">{{ birthMap.birth_taluka || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">Birth District</td>
                <td class="value-cell">{{ birthMap.birth_district || '' }}</td>
                <td class="label-cell">Birth State</td>
                <td class="value-cell">{{ birthMap.birth_state || '' }}</td>
            </tr>

            <tr>
                <td class="label-cell">Birth Country</td>
                <td class="value-cell">{{ birthMap.birth_country || '' }}</td>
                <td class="label-cell"></td>
                <td class="value-cell"></td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2">
          <div class="section-title">Parent Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:20%" />
              <col style="width:30%" />
              <col style="width:20%" />
              <col style="width:30%" />
            </colgroup>
            <tr>
              <td class="sub-section-title">Father Details</td>
              <td class="value-cell"></td>
              <td class="sub-section-title">Mother Details</td>
              <td class="value-cell"></td>
            </tr>

            <tr>
              <td class="label-cell">Father Photo</td>
              <td class="value-cell text-center">
                <img 
                  v-if="fatherMap.father_relative_photo_file" 
                  :src="fatherMap.father_relative_photo_file" 
                  alt="Father" 
                  class="parent-photo" 
                />
                <div v-else class="photo-placeholder-small">No Photo</div>
              </td>
              <td class="label-cell">Mother Photo</td>
              <td class="value-cell text-center">
                <img 
                  v-if="motherMap.mother_relative_photo_file" 
                  :src="motherMap.mother_relative_photo_file" 
                  alt="Mother" 
                  class="parent-photo" 
                />
                <div v-else class="photo-placeholder-small">No Photo</div>
              </td>
            </tr>

            <tr>
              <td class="label-cell">Father First Name</td>
              <td class="value-cell">{{ fatherMap.father_first_name || '' }}</td>
              <td class="label-cell">Mother First Name</td>
              <td class="value-cell">{{ motherMap.mother_first_name || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Father Middle Name</td>
              <td class="value-cell">{{ fatherMap.father_middle_name || '' }}</td>
              <td class="label-cell">Mother Middle Name</td>
              <td class="value-cell">{{ motherMap.mother_middle_name || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Father Last Name</td>
              <td class="value-cell">{{ fatherMap.father_last_name || '' }}</td>
              <td class="label-cell">Mother Last Name</td>
              <td class="value-cell">{{ motherMap.mother_last_name || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Father Full Name</td>
              <td class="value-cell">{{ fatherMap.father_full_name || '' }}</td>
              <td class="label-cell">Mother Full Name</td>
              <td class="value-cell">{{ motherMap.mother_full_name || '' }}</td>
            </tr>
             <tr>
              <td class="label-cell">Father Full Name As Per Doc</td>
              <td class="value-cell">{{ fatherMap.father_full_name_as_per_doc || '' }}</td>
              <td class="label-cell">Mother Full Name As Per Doc</td>
              <td class="value-cell">{{ motherMap.mother_full_name_as_per_doc || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Father Email</td>
              <td class="value-cell">{{ fatherMap.father_email || '' }}</td>
              <td class="label-cell">Mother Email</td>
              <td class="value-cell">{{ motherMap.mother_email || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Father Contact No.</td>
              <td class="value-cell">{{ fatherMap.father_contact_no || '' }}</td>
              <td class="label-cell">Mother Contact No.</td>
              <td class="value-cell">{{ motherMap.mother_contact_no || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Father Aadhar No.</td>
              <td class="value-cell">{{ fatherMap.father_aadhar_no || '' }}</td>
              <td class="label-cell">Mother Aadhar No.</td>
              <td class="value-cell">{{ motherMap.mother_aadhar_no || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Father Education</td>
              <td class="value-cell">{{ fatherMap.father_education || '' }}</td>
              <td class="label-cell">Mother Education</td>
              <td class="value-cell">{{ motherMap.mother_education || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Father DOB</td>
              <td class="value-cell">{{ fatherMap.father_dob || '' }}</td>
              <td class="label-cell">Mother DOB</td>
              <td class="value-cell">{{ motherMap.mother_dob || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Father Occupation</td>
              <td class="value-cell">{{ fatherMap.father_relative_occupation || '' }}</td>
              <td class="label-cell">Mother Occupation</td>
              <td class="value-cell">{{ motherMap.mother_relative_occupation || '' }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2" v-if="(sibling1 && sibling1.sibling_name) || (sibling2 && sibling2.sibling_name)">
          <div class="section-title">Sibling Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:20%" />
              <col style="width:30%" />
              <col style="width:20%" />
              <col style="width:30%" />
            </colgroup>
            <tr>
              <td class="sub-section-title">Sibling 1 Details</td>
              <td class="value-cell"></td>
              <td class="sub-section-title">Sibling 2 Details</td>
              <td class="value-cell"></td>
            </tr>
            <tr>
              <td class="label-cell">Sibling 1 Name</td>
              <td class="value-cell">{{ sibling1.sibling_name || '' }}</td>
              <td class="label-cell">Sibling 2 Name</td>
              <td class="value-cell">{{ sibling2.sibling_name || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Sibling 1 School</td>
              <td class="value-cell">{{ sibling1.sibling_name_of_school || '' }}</td>
              <td class="label-cell">Sibling 2 School</td>
              <td class="value-cell">{{ sibling2.sibling_name_of_school || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Sibling 1 DOB</td>
              <td class="value-cell">{{ sibling1.sibling_date_of_birth || '' }}</td>
              <td class="label-cell">Sibling 2 DOB</td>
              <td class="value-cell">{{ sibling2.sibling_date_of_birth || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Sibling 1 Standard</td>
              <td class="value-cell">{{ sibling1.sibling_standard || '' }}</td>
              <td class="label-cell">Sibling 2 Standard</td>
              <td class="value-cell">{{ sibling2.sibling_standard || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Sibling 1 Relation</td>
              <td class="value-cell">{{ sibling1.sibling_relationtype || '' }}</td>
              <td class="label-cell">Sibling 2 Relation</td>
              <td class="value-cell">{{ sibling2.sibling_relationtype || '' }}</td>
            </tr>
          </table>
        </div>

         <div class="section-block mt-2">
          <div class="section-title">Caste Information</div>
          <table class="form-table">
            <colgroup>
                <col style="width:20%" />
                <col style="width:30%" />
                <col style="width:20%" />
                <col style="width:30%" />
            </colgroup>
            <tr>
                <td class="label-cell">Quota</td>
                <td class="value-cell">{{ categoryMap.quota || '' }}</td>
                <td class="label-cell">Category</td>
                <td class="value-cell">{{ categoryMap.category || '' }}</td>
            </tr>
            <tr>
                <td class="label-cell">Religion</td>
                <td class="value-cell">{{ categoryMap.religion || '' }}</td>
                <td class="label-cell">Caste</td>
                <td class="value-cell">{{ categoryMap.cast || '' }}</td>
            </tr>
            <tr>
                <td class="label-cell">Sub Caste</td>
                <td class="value-cell">{{ categoryMap.sub_caste || '' }}</td>
                <td class="label-cell"></td>
                <td class="value-cell"></td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2">
          <div class="section-title">Local Address Details</div>
          <table class="form-table">
            <tr>
              <td class="label-cell" style="width:18%">Address</td>
              <td class="value-cell" colspan="5">{{ addressMap.laddress || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell" style="width:18%">Country</td>
              <td class="value-cell" style="width:15%">{{ addressMap.lcountry || '' }}</td>
              <td class="label-cell" style="width:15%">State</td>
              <td class="value-cell" style="width:15%">{{ addressMap.lstate || '' }}</td>
              <td class="label-cell" style="width:15%">City</td>
              <td class="value-cell">{{ addressMap.lcity || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">District</td>
              <td class="value-cell">{{ addressMap.ldistrict || '' }}</td>
              <td class="label-cell">Taluka</td>
              <td class="value-cell">{{ addressMap.ltaluka || '' }}</td>
              <td class="label-cell">Pincode</td>
              <td class="value-cell">{{ addressMap.lpin || '' }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2">
          <div class="section-title">Permanent Address Details</div>
          <table class="form-table">
            <tr>
              <td class="label-cell" style="width:18%">Address</td>
              <td class="value-cell" colspan="5">{{ addressMap.paddress || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell" style="width:18%">Country</td>
              <td class="value-cell" style="width:15%">{{ addressMap.pcountry || '' }}</td>
              <td class="label-cell" style="width:15%">State</td>
              <td class="value-cell" style="width:15%">{{ addressMap.pstate || '' }}</td>
              <td class="label-cell" style="width:15%">City</td>
              <td class="value-cell">{{ addressMap.pcity || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">District</td>
              <td class="value-cell">{{ addressMap.pdistrict || '' }}</td>
              <td class="label-cell">Taluka</td>
              <td class="value-cell">{{ addressMap.ptaluka || '' }}</td>
              <td class="label-cell">Pincode</td>
              <td class="value-cell">{{ addressMap.ppin || '' }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2">
          <div class="section-title">Guardian Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:20%" />
              <col style="width:30%" />
              <col style="width:20%" />
              <col style="width:30%" />
            </colgroup>
            <tr>
              <td class="sub-section-title">Guardian 1 Details</td>
              <td class="value-cell"></td>
              <td class="sub-section-title">Guardian 2 Details</td>
              <td class="value-cell"></td>
            </tr>

            <tr>
              <td class="label-cell">Guardian 1 Photo</td>
              <td class="value-cell text-center">
                <img 
                  v-if="guardian1Map.guardian1_photo" 
                  :src="guardian1Map.guardian1_photo.startsWith('http') ? guardian1Map.guardian1_photo : (awspath + guardian1Map.guardian1_photo)" 
                  alt="Guardian 1" 
                  class="parent-photo" 
                />
                <div v-else class="photo-placeholder-small">No Photo</div>
              </td>
              <td class="label-cell">Guardian 2 Photo</td>
              <td class="value-cell text-center">
                <img 
                  v-if="guardian2Map.guardian2_photo" 
                  :src="guardian2Map.guardian2_photo.startsWith('http') ? guardian2Map.guardian2_photo : (awspath + guardian2Map.guardian2_photo)" 
                  alt="Guardian 2" 
                  class="parent-photo" 
                />
                <div v-else class="photo-placeholder-small">No Photo</div>
              </td>
            </tr>

            <tr>
              <td class="label-cell">Guardian 1 Name</td>
              <td class="value-cell">{{ guardian1Map.guardian1_name || '' }}</td>
              <td class="label-cell">Guardian 2 Name</td>
              <td class="value-cell">{{ guardian2Map.guardian2_name || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Guardian 1 Contact No.</td>
              <td class="value-cell">{{ guardian1Map.guardian1_contact || '' }}</td>
              <td class="label-cell">Guardian 2 Contact No.</td>
              <td class="value-cell">{{ guardian2Map.guardian2_contact || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Guardian 1 Aadhar No.</td>
              <td class="value-cell">{{ guardian1Map.guardian1_aadhar_no || '' }}</td>
              <td class="label-cell">Guardian 2 Aadhar No.</td>
              <td class="value-cell">{{ guardian2Map.guardian2_aadhar_no || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Guardian 1 Address</td>
              <td class="value-cell">{{ guardian1Map.guardian_address || '' }}</td>
              <td class="label-cell">Guardian 2 Address</td>
              <td class="value-cell">{{ guardian2Map.guardian2_address || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Guardian 1 Relation</td>
              <td class="value-cell">{{ guardian1Map.guardian1_relation || '' }}</td>
              <td class="label-cell">Guardian 2 Relation</td>
              <td class="value-cell">{{ guardian2Map.guardian2_relation || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Guardian 1 Occupation</td>
              <td class="value-cell">{{ guardian1Map.guardian1_occupation || '' }}</td>
              <td class="label-cell">Guardian 2 Occupation</td>
              <td class="value-cell">{{ guardian2Map.guardian2_occupation || '' }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2">
          <div class="section-title">Last Attended School Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:25%" />
              <col style="width:25%" />
              <col style="width:25%" />
              <col style="width:25%" />
            </colgroup>
            <tr>
              <td class="label-cell">School Medium</td>
              <td class="value-cell">{{ schoolAttendedMap.school_medium || '' }}</td>
              <td class="label-cell">Previous School Name</td>
              <td class="value-cell">{{ schoolAttendedMap.previous_school_name || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Previous School Passing Standard</td>
              <td class="value-cell">{{ schoolAttendedMap.previousschoolpassingstandard || '' }}</td>
              <td class="label-cell">Previous School Obtained Percentage</td>
              <td class="value-cell">{{ schoolAttendedMap.previous_school_obtained_percentage || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Reason for Leaving Last School</td>
              <td class="value-cell">{{ schoolAttendedMap.reason_for_leaving_last_school || '' }}</td>
              <td class="label-cell">Admitted Standard</td>
              <td class="value-cell">{{ schoolAttendedMap.admittedstandard || '' }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2" v-if="subject_list && subject_list.length > 0">
          <div class="section-title">Current Subjects</div>
          <table class="form-table">
            <colgroup>
              <col style="width:10%" />
              <col style="width:65%" />
              <col style="width:25%" />
            </colgroup>
            <tr>
              <td class="label-cell text-center">Sr. No</td>
              <td class="label-cell">Course Name</td>
              <td class="label-cell text-center">Course Rule</td>
            </tr>
            <tr v-for="subject in subject_list" :key="subject.srno">
              <td class="text-center">{{ subject.srno }}</td>
              <td>{{ subject.course_name }}</td>
              <td class="text-center">{{ subject.course_rule }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2">
          <div class="section-title">Uploaded Documents Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:10%" />
              <col style="width:40%" />
              <col style="width:35%" />
              <col style="width:15%" />
            </colgroup>
            <tr>
              <td class="label-cell text-center">Sr. No</td>
              <td class="label-cell">Uploaded Document Name</td>
              <td class="label-cell">Remark</td>
              <td class="label-cell text-center print-hide-col">View</td>
            </tr>
            <tr v-for="doc in student_documents_list" :key="doc.document_id">
                <td class="text-center">{{ doc.srno }}</td>
                <td>{{ doc.document_name }}</td>
                <td>{{ doc.document_remark || '-' }}</td>
                <td class="text-center print-hide-col">
                  <a v-if="doc.document_path && doc.document_path !== 'NA'" 
                     :href="getDocumentUrl(doc.document_path)" 
                     target="_blank" class="view-icon" title="View Document">
                     <i class="mdi mdi-eye"></i>
                  </a>
                  <span v-else>-</span>
                </td>
            </tr>

            <tr v-if="!student_documents_list || student_documents_list.length === 0">
                <td colspan="4" style="text-align:center;">
                    No documents uploaded.
                </td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2" v-if="transportFields && transportFields.length > 0">
          <div class="section-title">Transport Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:20%" />
              <col style="width:30%" />
              <col style="width:20%" />
              <col style="width:30%" />
            </colgroup>
            <tr>
              <td class="label-cell">Transport Mode</td>
              <td class="value-cell">{{ transportMap.transport_mode || '' }}</td>
              <td class="label-cell">Vehicle No</td>
              <td class="value-cell">{{ transportMap.vehicle_no || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Driver Name</td>
              <td class="value-cell">{{ transportMap.driver_name || '' }}</td>
              <td class="label-cell">Driver Contact</td>
              <td class="value-cell">{{ transportMap.driver_contact || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Driver Aadhar No</td>
              <td class="value-cell">{{ transportMap.driver_aadhar_no || '' }}</td>
              <td class="label-cell">Driver Address</td>
              <td class="value-cell">{{ transportMap.driver_address || '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Pickup Time</td>
              <td class="value-cell">{{ transportMap.transport_pickup_time || '' }}</td>
              <td class="label-cell">Drop Time</td>
              <td class="value-cell">{{ transportMap.transport_drop_time || '' }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2" v-if="hasMedicalData">
          <div class="section-title">Medical Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:20%" />
              <col style="width:30%" />
              <col style="width:20%" />
              <col style="width:30%" />
            </colgroup>
            <tr>
              <td class="label-cell">Height</td>
              <td class="value-cell">{{ medical_details && medical_details.height ? medical_details.height.value : '' }}</td>
              <td class="label-cell">Weight</td>
              <td class="value-cell">{{ medical_details && medical_details.weight ? medical_details.weight.value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Allergy</td>
              <td class="value-cell">{{ medical_details && medical_details.allergy ? medical_details.allergy.value : '' }}</td>
              <td class="label-cell">Medical Condition</td>
              <td class="value-cell">{{ medical_details && medical_details.medical_condition ? medical_details.medical_condition.value : '' }}</td>
            </tr>
          </table>

          <table class="form-table" style="border-top:none;">
            <colgroup>
              <col style="width:20%" />
              <col style="width:30%" />
              <col style="width:20%" />
              <col style="width:30%" />
            </colgroup>
            <tr>
              <td class="sub-section-title" colspan="4">Family Physician Details</td>
            </tr>
            <tr>
              <td class="label-cell">Doctor Name</td>
              <td class="value-cell">{{ family_physician_details && family_physician_details.family_doctor_name ? family_physician_details.family_doctor_name.value : '' }}</td>
              <td class="label-cell">Doctor Contact</td>
              <td class="value-cell">{{ family_physician_details && family_physician_details.family_doctor_contact ? family_physician_details.family_doctor_contact.value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Hospital Name</td>
              <td class="value-cell">{{ family_physician_details && family_physician_details.emrg_hospital_name ? family_physician_details.emrg_hospital_name.value : '' }}</td>
              <td class="label-cell">Hospital Number</td>
              <td class="value-cell">{{ family_physician_details && family_physician_details.emrg_hospital_number ? family_physician_details.emrg_hospital_number.value : '' }}</td>
            </tr>
            <tr>
              <td class="label-cell">Hospital Address</td>
              <td class="value-cell" colspan="3">{{ family_physician_details && family_physician_details.emrgency_hospital_address ? family_physician_details.emrgency_hospital_address.value : '' }}</td>
            </tr>
          </table>

          <table class="form-table" style="border-top:none;" v-if="child_vaccination_list && child_vaccination_list.length > 0">
            <colgroup>
              <col style="width:10%" />
              <col style="width:30%" />
              <col style="width:30%" />
              <col style="width:15%" />
              <col style="width:15%" />
            </colgroup>
            <tr>
              <td class="sub-section-title" colspan="5">Vaccination Details</td>
            </tr>
            <tr>
              <td class="label-cell text-center">Sr. No</td>
              <td class="label-cell">Date</td>
              <td class="label-cell">Name</td>
              <td class="label-cell">Is Compliance</td>
              <td class="label-cell text-center print-hide-col">View</td>
            </tr>
            <tr v-for="vac in child_vaccination_list" :key="vac.id">
              <td class="text-center">{{ vac.srno }}</td>
              <td>{{ getFieldValue(vac.fields, 'Under_medical_tab__vaccination_date') }}</td>
              <td>{{ getFieldValue(vac.fields, 'Under_medical_tab__vaccination_name') }}</td>
              <td>{{ getFieldValue(vac.fields, 'Under_medical_tab__vaccination_iscompliance') ? 'Yes' : 'No' }}</td>
              <td class="text-center print-hide-col">
                <a v-if="getFieldValue(vac.fields, 'Under_medical_tab__vaccination_attachment') && getFieldValue(vac.fields, 'Under_medical_tab__vaccination_attachment') !== 'NA'" 
                   :href="getDocumentUrl(getFieldValue(vac.fields, 'Under_medical_tab__vaccination_attachment'))" 
                   target="_blank" class="view-icon" title="View Document">
                  <i class="mdi mdi-eye"></i>
                </a>
                <span v-else>-</span>
              </td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2" v-if="awardDetails && awardDetails.awards && awardDetails.awards.length > 0">
          <div class="section-title">Awards Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:10%" />
              <col style="width:20%" />
              <col style="width:25%" />
              <col style="width:30%" />
              <col style="width:15%" />
            </colgroup>
            <tr>
              <td class="label-cell text-center">Sr. No</td>
              <td class="label-cell">Academic Year</td>
              <td class="label-cell">Title</td>
              <td class="label-cell">Description</td>
              <td class="label-cell text-center print-hide-col">Certificate</td>
            </tr>
            <tr v-for="award in awardDetails.awards" :key="award.id">
              <td class="text-center">{{ award.srno }}</td>
              <td>{{ getFieldValue(award.fields, 'academicyear') }}</td>
              <td>{{ getFieldValue(award.fields, 'title') }}</td>
              <td>{{ getFieldValue(award.fields, 'description') }}</td>
              <td class="text-center print-hide-col">
                <a v-if="getFieldValue(award.fields, 'award_letter') && getFieldValue(award.fields, 'award_letter') !== 'NA'" 
                   :href="getDocumentUrl(getFieldValue(award.fields, 'award_letter'))" 
                   target="_blank" class="view-icon" title="View Document">
                   <i class="mdi mdi-eye"></i>
                </a>
                <span v-else>-</span>
              </td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2" v-if="student_activity_list && student_activity_list.length > 0">
          <div class="section-title">Student Activities Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:5%" />
              <col style="width:20%" />
              <col style="width:10%" />
              <col style="width:15%" />
              <col style="width:10%" />
              <col style="width:10%" />
              <col style="width:15%" />
              <col style="width:15%" />
            </colgroup>
            <tr>
              <td class="label-cell text-center">Sr. No</td>
              <td class="label-cell">Activity Name</td>
              <td class="label-cell">Type</td>
              <td class="label-cell">Role</td>
              <td class="label-cell">Level</td>
              <td class="label-cell">Honours</td>
              <td class="label-cell">Academic Year</td>
              <td class="label-cell">Dates</td>
            </tr>
            <tr v-for="activity in student_activity_list" :key="activity.id">
              <td class="text-center">{{ activity.srno }}</td>
              <td>{{ activity.activity_name }}</td>
              <td>{{ activity.activity_type_name }}</td>
              <td>{{ activity.role }}</td>
              <td>{{ activity.level }}</td>
              <td>{{ activity.honours }}</td>
              <td>{{ activity.academicyear_name }}</td>
              <td>{{ activity.from_date }} to {{ activity.to_date }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2" v-if="skills_list && skills_list.length > 0">
          <div class="section-title">Skills Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:10%" />
              <col style="width:90%" />
            </colgroup>
            <tr>
              <td class="label-cell text-center">Sr. No</td>
              <td class="label-cell">Skill Name</td>
            </tr>
            <tr v-for="skill in skills_list" :key="skill.id">
              <td class="text-center">{{ skill.srno }}</td>
              <td>{{ skill.name }}</td>
            </tr>
          </table>
        </div>

        <div class="section-block mt-2" v-if="interest_list && interest_list.length > 0">
          <div class="section-title">Interests Details</div>
          <table class="form-table">
            <colgroup>
              <col style="width:10%" />
              <col style="width:90%" />
            </colgroup>
            <tr>
              <td class="label-cell text-center">Sr. No</td>
              <td class="label-cell">Interest Name</td>
            </tr>
            <tr v-for="interest in interest_list" :key="interest.id">
              <td class="text-center">{{ interest.srno }}</td>
              <td>{{ interest.name }}</td>
            </tr>
          </table>
        </div>

      </div>

       <div class="print-page instructions-page" v-if="admission_instruction">
            <div
                class="dynamic-content-wrapper"
                v-html="admission_instruction.admission_instructions_html_code">
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
    name: "StudentProfileForm",
    data() {
        return {
            fields: [],
            addressFields: [],
            transportFields: [], 
            parentDetails: {
                father: { present: false, fields: [] },
                mother: { present: false, fields: [] }
            },
            guardianData: {
                guardian1: { present: false, fields: [] },
                guardian2: { present: false, fields: [] }
            },
            sibling1: {}, 
            sibling2: {}, 
            PhysicallyChallenged: null,
            disability_type_list: [],

            medical_details: {},
            family_physician_details: {},
            health_cards: [],
            child_vaccination_list: [],

            awardDetails: {},

            student_activity_list: [],
            skills_list: [],
            interest_list: [],
            
            subject_list: [],
            ay_list: [],
            ay: null,

            CategoryDetails: [],
            birthDetails: {},
            schoolAttendedData: {},
            standard_list: [],
            student_documents_list:[],
            org_basic_data: null,
            learner_photo: "",
            learner: "",
            awspath: "",
            aws_path: "", 
            snackbar: false,
            color: "",
            snackbar_msg: "",
            admission_instruction: null,
        };
    },
    computed: {
        studentMap() {
            const map = {};
            if (Array.isArray(this.fields)) {
                this.fields.forEach(field => {
                    if (field && field.field_name) {
                        map[field.field_name] = field.value !== undefined && field.value !== null ? field.value : "";
                    }
                });
            }
            return map;
        },
        birthMap() {
            const map = {};
            if (this.birthDetails && typeof this.birthDetails === "object") {
                Object.keys(this.birthDetails).forEach(key => {
                    if (this.birthDetails[key]) {
                        map[key] = this.birthDetails[key].value !== undefined && this.birthDetails[key].value !== null ? this.birthDetails[key].value : "";
                    }
                });
            }
            return map;
        },
        fatherMap() {
            const map = {};
            if (this.parentDetails && this.parentDetails.father && Array.isArray(this.parentDetails.father.fields)) {
                this.parentDetails.father.fields.forEach(field => {
                    if (field && field.field_name) {
                        map[field.field_name] = field.value !== undefined && field.value !== null ? field.value : "";
                    }
                });
            }
            return map;
        },
        motherMap() {
            const map = {};
            if (this.parentDetails && this.parentDetails.mother && Array.isArray(this.parentDetails.mother.fields)) {
                this.parentDetails.mother.fields.forEach(field => {
                    if (field && field.field_name) {
                        map[field.field_name] = field.value !== undefined && field.value !== null ? field.value : "";
                    }
                });
            }
            return map;
        },
        categoryMap() {
            const map = {};
            if (this.CategoryDetails && typeof this.CategoryDetails === "object") {
                Object.keys(this.CategoryDetails).forEach(key => {
                    if (this.CategoryDetails[key]) {
                        map[key] = this.CategoryDetails[key].value !== undefined && this.CategoryDetails[key].value !== null ? this.CategoryDetails[key].value : "";
                    }
                });
            }
            return map;
        },
        addressMap() {
            const map = {};
            if (Array.isArray(this.addressFields)) {
                this.addressFields.forEach(field => {
                    if (field && field.field_name) {
                        map[field.field_name] = field.value !== undefined && field.value !== null ? field.value : "";
                    }
                });
            }
            return map;
        },
        guardian1Map() {
            const map = {};
            if (this.guardianData && this.guardianData.guardian1 && Array.isArray(this.guardianData.guardian1.fields)) {
                this.guardianData.guardian1.fields.forEach(field => {
                    if (field && field.field_name) {
                        map[field.field_name] = field.value !== undefined && field.value !== null ? field.value : "";
                    }
                });
            }
            return map;
        },
        guardian2Map() {
            const map = {};
            if (this.guardianData && this.guardianData.guardian2 && Array.isArray(this.guardianData.guardian2.fields)) {
                this.guardianData.guardian2.fields.forEach(field => {
                    if (field && field.field_name) {
                        map[field.field_name] = field.value !== undefined && field.value !== null ? field.value : "";
                    }
                });
            }
            return map;
        },
        schoolAttendedMap() {
            const map = {};
            if (this.schoolAttendedData && typeof this.schoolAttendedData === "object") {
                Object.keys(this.schoolAttendedData).forEach(key => {
                    const field = this.schoolAttendedData[key];
                    if (field && typeof field === "object") {
                        if (field.type === "select" && Array.isArray(field.options)) {
                            const selectedOption = field.options.find(opt => opt.id === field.value);
                            map[key] = selectedOption ? selectedOption.name : "";
                        } else {
                            map[key] = field.value !== undefined && field.value !== null ? field.value : "";
                        }
                    }
                });
            }
            return map;
        },
        transportMap() {
            const map = {};
            if (Array.isArray(this.transportFields)) {
                this.transportFields.forEach(field => {
                    if (field && field.field_name) {
                        map[field.field_name] = field.value !== undefined && field.value !== null ? field.value : "";
                    }
                });
            }
            return map;
        },
        hasMedicalData() {
            return (
                (this.medical_details && Object.keys(this.medical_details).length > 0) ||
                (this.family_physician_details && Object.keys(this.family_physician_details).length > 0) ||
                (this.child_vaccination_list && this.child_vaccination_list.length > 0) ||
                (this.health_cards && this.health_cards.length > 0)
            );
        }
    },
    methods: {
        printForm() {
            setTimeout(() => window.print(), 200);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getFieldValue(fields, fieldName) {
            if (!Array.isArray(fields)) return '';
            const field = fields.find(f => f.field_name === fieldName);
            return field && field.value !== undefined && field.value !== null ? field.value : '';
        },
        getDocumentUrl(path) {
            if (!path || path === 'NA') return '';
            if (path.startsWith('http')) return path;
            const base = this.aws_path || this.awspath || '';
            return base + path;
        },
        getChildDataForProfile() {
            const data = { learner: this.learner };
            axios.post("/parent/getChildDataForProfile", data).then((res) => {
                if (res.data.flag == "YES") {
                    this.fields = res.data.fields;
                    this.learner_photo = res.data.learner_photo;
                } else {
                    this.showSnackbar("error", res.data.snackbar);
                }
            });
        },
        getParentDataForProfile() {
            const data = { learner: this.learner };
            axios.post("/parent/getParentDataForProfile", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        const motherData = res.data.parentDetails.mother || { present: false, fields: [] };
                        const fatherData = res.data.parentDetails.father || { present: false, fields: [] };
                        const motherFields = Array.isArray(motherData.fields) ? motherData.fields : [];
                        const fatherFields = Array.isArray(fatherData.fields) ? fatherData.fields : [];
                        const motherPhotoObj = motherFields.find(f => f.field_name === "mother_relative_photo_file");
                        const fatherPhotoObj = fatherFields.find(f => f.field_name === "father_relative_photo_file");
                        this.$set(this, "parentDetails", {
                            learner_id: res.data.parentDetails.learner_id || "",
                            mother: {
                                present: motherData.present || false,
                                fields: motherFields.map(field => ({ ...field, value: field.value || "" })),
                                photo: null,
                                old_photo: motherPhotoObj ? motherPhotoObj.value : null
                            },
                            father: {
                                present: fatherData.present || false,
                                fields: fatherFields.map(field => ({ ...field, value: field.value || "" })),
                                photo: null,
                                old_photo: fatherPhotoObj ? fatherPhotoObj.value : null
                            }
                        });
                    } else {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching parent data:", error);
                    this.showSnackbar("error", "Failed to fetch parent data.");
                });
        },
        getChildBirthDetails() {
            const data = { learner: this.learner };
            axios.post("/parent/getChildBirthDetails", data).then((res) => {
                if (res.data.flag == "YES") {
                    this.birthDetails = res.data.birthDetails;
                } else {
                    this.showSnackbar("error", res.data.snackbar);
                }
            });
        },
        getChildCategoryDetails() {
            const data = { learner: this.learner };
            axios.post("/parent/getChildCategoryDetails", data).then((res) => {
                if (res.data.flag == "YES") {
                    this.CategoryDetails = res.data.CategoryDetails;
                } else {
                    this.showSnackbar("error", res.data.snackbar);
                }
            });
        },
        getChildDisabilityDetails() {
            const data = { learner: this.learner };
            axios.post("/parent/getChildDisabilityDetails", data).then((res) => {
                if (res.data.flag == "YES") {
                    this.PhysicallyChallenged = res.data.PhysicallyChallenged;
                    this.disability_type_list = res.data.disability_type_list;
                } else {
                    this.showSnackbar("error", "Something went wrong.");
                }
            });
        },
        getChildSiblingForProfile() {
            const data = { learner: this.learner };
            axios.post("/parent/getSiblingForProfile", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.sibling1 = res.data.sibling1 || {};
                        this.sibling2 = res.data.sibling2 || {};
                        this.standard_list = res.data.standard_list || [];
                    } else {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching sibling data:", err);
                    this.showSnackbar("error", "Failed to fetch sibling data.");
                });
        },
        getChildAddressDetails() {
            const data = { learner: this.learner };
            axios.post("/parent/getChildAddressDetails", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.addressFields = res.data.fields;
                    } else {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching address details:", error);
                });
        },
        getChildGuardian() {
            axios.post("/Parent/getChildGuardian", { learner: this.learner })
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.guardianData = res.data.guardianDetails;
                    } else {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching guardian data:", error);
                    this.showSnackbar("error", "Failed to fetch guardian data.");
                });
        },
        getChildPreviousSchoolDetails() {
            const data = { learner: this.learner };
            axios.post("/parent/getChildPreviousSchoolDetails", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.schoolAttendedData = res.data.schoolAttended || {};
                        this.org_basic_data = res.data.org_basic_data;
                    } else {
                        this.showSnackbar("error", res.data.snackbar || "Something went wrong.");
                    }
                })
                .catch((error) => {
                    console.error("Error fetching school data:", error);
                    this.showSnackbar("error", "Server error occurred.");
                });
        },
        getStudentDocuments() {
            const formData = {
                 learner: this.learner,
            };
            axios.post("/parent/getStudentDocuments", formData)
            .then((res) => {
                if (res.data.flag === "YES") {
                    this.student_documents_list = res.data.student_documents_list;
                    this.admission_instruction = res.data.admission_instruction;
                } else {
                    this.showSnackbar( "#ff9800",res.data.message || "Unable to fetch Document data.");
                }
            })
            .catch((error) => {
                console.error("Error in getStudentDocuments:", error);
                this.showSnackbar("#b71c1c","Something went wrong while fetching activities!");
            });
        },
        getChildTransportDetails() {
            const data = { learner: this.learner };
            axios
            .post("/parent/getChildTransportDetails", data)
            .then((res) => {
                if (res.data.flag === "YES") {
                    this.transportFields = res.data.fields; 
                } else {
                    this.showSnackbar("error", res.data.snackbar || "Something went wrong...");
                }
            })
            .catch(() => { });
        },
        getMedicalDetails() {
            const data = { learner: this.learner };
            axios
            .post("/parent/getMedicalDetails", data)
            .then((res) => {
                if (res.data.flag === "YES") {
                    this.medical_details = res.data.medical_details || {};
                    this.family_physician_details = res.data.family_physician_details || {};
                    this.health_cards = res.data.health_cards || [];
                    this.child_vaccination_list = res.data.child_vaccination_list || [];
                    if(res.data.aws_path) this.aws_path = res.data.aws_path;
                } else {
                    this.showSnackbar("error", res.data.snackbar);
                }
            })
            .catch((error) => {
                console.error("Error fetching medical details:", error);
                this.showSnackbar("error", "Failed to fetch medical details");
            });
        },
        getData() {
            const formData = { learner: this.learner };
            axios
            .post("/EmployeeProfile/getStudentAwardsNew", formData)
            .then((res) => {
                if (res.data.flag === "YES") {
                    this.awardDetails = res.data.awardDetails || {};
                    if(res.data.aws_path) this.aws_path = res.data.aws_path;
                } else {
                    this.showSnackbar("error", res.data.snackbar);
                }
            })
            .catch((error) => {
                this.showSnackbar("error", "Failed to fetch award data.");
                console.error(error);
            });
        },
        getStudentActivity() {
            const formData = {
                learner: this.learner,
            };
            axios
            .post("/parent/getStudentActivity", formData)
            .then((res) => {
                const data = res.data;
                if (data && data.flag === "YES") {
                    this.student_activity_list = data.student_activity_list || [];
                } else {
                    this.showSnackbar("#ff9800", data.message || "Unable to fetch activity data.");
                }
            })
            .catch((error) => {
                console.error("Error in getStudentActivity:", error);
                this.showSnackbar("#b71c1c", "Something went wrong while fetching activities!");
            });
        },
        getSkillDetails() {
            const data = { learner: this.learner };
            axios.post("/parent/getSkillDetails", data)
            .then((res) => {
                if (res.data.flag === "YES") {
                    this.skills_list = res.data.skills_list || [];
                } else {
                    this.showSnackbar("#b71c1c", res.data.snackbar || "Error loading skills");
                }
            }).catch((error) => {
                console.error("Error fetching skills:", error);
                this.showSnackbar("#b71c1c", "Failed to load skills");
            });
        },
        getLearnerInterest() {
            const data = { learner: this.learner };
            axios.post("/parent/getLearnerInterest", data)
            .then((res) => {
                if (res.data.flag === "YES") {
                    this.interest_list = res.data.interest_list || [];
                } else {
                    this.showSnackbar("#b71c1c", res.data.snackbar || "Error loading interests");
                }
            }).catch((error) => {
                console.error("Error fetching interests:", error);
                this.showSnackbar("#b71c1c", "Failed to load interests");
            });
        },
        getCurrentSubject() {
        axios
            .post("/parent/getCurrentSubject", { learner: this.learner })
            .then((res) => {
            if (res.data.flag === "YES") {
                this.subject_list = res.data.subject_list;
                this.subject_list = res.data.subject_list.filter(
                subject => subject.course_name !== "NA : NA"
                );

                this.ay_list = res.data.ay_list;
                this.ay = res.data.ay_list[0];
            } else {
                this.showSnackbar("error", res.data.snackbar || "Something went wrong...");
            }
            })
            .catch(() => {
            this.showSnackbar("error", "Server error while fetching subject data.");
            });
        },
    },
    mounted() {
        this.learner = localStorage.getItem("learner_for_profile");
        this.awspath = localStorage.getItem("awspath") || "";
        if (this.learner) {
            this.getChildDataForProfile();
            this.getParentDataForProfile();
            this.getChildBirthDetails();
            this.getChildCategoryDetails();
            this.getChildDisabilityDetails();
            this.getChildSiblingForProfile();
            this.getChildAddressDetails();
            this.getChildGuardian();
            this.getChildPreviousSchoolDetails();
            this.getStudentDocuments();
            this.getChildTransportDetails();
            this.getMedicalDetails();
            this.getData();
            this.getStudentActivity();
            this.getSkillDetails();
            this.getLearnerInterest();
            this.getCurrentSubject();
        }
    }
};
</script>

<style>
*,
*::before,
*::after {
    box-sizing: border-box;
}

html,
body {
    margin: 0;
    padding: 0;
    font-family: "Times New Roman", serif;
    background: #fff;
}

#one_view_form {
    width: 100%;
    max-width: 900px;
    margin: 20px auto;
}

.no-print {
    text-align: center;
    margin-bottom: 20px;
}

.print-btn {
    padding: 8px 20px;
    font-size: 14px;
    border: 1px solid #1565c0;
    color: #1565c0;
    background: white;
    cursor: pointer;
}

.print-btn:hover {
    background: #1565c0;
    color: white;
}

.form-wrapper {
    padding: 15px;
}

.print-page {
    background: #fff;
    padding: 15px;
}

.header-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border: 2px solid #000;
}

.header-table td {
    border: 1px solid #000;
    padding: 8px;
    vertical-align: middle;
}

.header-logo-cell {
    width: 90px;
    text-align: center;
}

.header-photo-cell {
    width: 100px;
    text-align: center;
}

.header-info-cell {
    text-align: center;
}

.college-logo {
    width: 70px;
    height: auto;
}

.student-photo {
    width: 85px;
    height: 105px;
    object-fit: cover;
    border: 1px solid #000;
}

.logo-placeholder,
.photo-placeholder {
    width: 70px;
    height: 70px;
    border: 1px solid #000;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
}

.parent-photo {
    width: 70px;
    height: 85px;
    object-fit: cover;
    border: 1px solid #000;
    display: block;
    margin: 0 auto;
}

.photo-placeholder-small {
    width: 70px;
    height: 85px;
    border: 1px solid #000;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    background: #f5f5f5;
    margin: 0 auto;
}

.view-icon {
    color: #1565c0;
    text-decoration: none;
    display: inline-block;
    vertical-align: middle;
    transition: color 0.2s ease;
}

.view-icon:hover {
    color: #0d47a1;
}

.view-icon svg {
    width: 18px;
    height: 18px;
}

.college-name {
    margin: 0;
    font-size: 22px;
    font-weight: bold;
    text-transform: uppercase;
}

.college-address {
    font-size: 13px;
    margin-top: 5px;
}

.section-block {
    margin-top: 12px;
}

.section-title {
    background: #d9d9d9;
    border: 2px solid #000;
    border-bottom: none;
    padding: 6px;
    text-align: center;
    font-weight: bold;
    font-size: 13px;
}

.form-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border: 2px solid #000;
}

.form-table td {
    border: 1px solid #000;
    padding: 5px 6px;
    vertical-align: middle;
    font-size: 12px;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.label-cell {
    background: #efefef;
    font-weight: bold;
}

.value-cell {
    background: white;
}

.sub-section-title {
    background: #e4e4e4;
    font-weight: bold;
}

.sub-label {
    background: #efefef;
    text-align: center;
    font-size: 11px;
}

.text-center {
    text-align: center;
}

@page {
    size: A4 portrait;
    margin: 8mm;
}

@media print {
    html,
    body {
        width: 210mm;
        background: white;
        margin: 0;
        padding: 0;
        font-size: 12px;
    }

    .no-print,
    .print-btn,
    .print-hide-col {
        display: none !important;
    }

    #one_view_form {
        margin: 0 !important;
        padding: 0 !important;
        max-width: 100% !important;
    }

    .form-wrapper {
        padding: 0;
    }

    .print-page {
        padding: 0;
        width: 100%;
    }

    table {
        width: 100% !important;
        border-collapse: collapse !important;
        border-spacing: 0 !important;
        page-break-inside: auto;
    }

    tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }

    td {
        border: 1px solid #000 !important;
        padding: 5px !important;
        font-size: 11px;
        word-break: break-word;
    }

    .header-table {
        border: 2px solid #000 !important;
    }

    .form-table {
        border: 2px solid #000 !important;
    }

    .section-title {
        border: 2px solid #000 !important;
        border-bottom: none !important;
        background: #d9d9d9 !important;
    }

    .label-cell {
        background: #efefef !important;
    }

    .sub-section-title {
        background: #e4e4e4 !important;
    }

    .sub-label {
        background: #efefef !important;
    }

    .college-logo {
        width: 65px;
    }

    .student-photo {
        width: 80px;
        height: 100px;
    }

    .parent-photo,
    .photo-placeholder-small {
        width: 60px;
        height: 75px;
    }

    img {
        max-width: 100%;
    }

   .section-block {
        page-break-inside: auto;
        break-inside: auto;
    }

    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .form-wrapper,
    .print-page {
        margin: 0 !important;
        padding: 0 !important;
    }

    html,
    body,
    #app,
    .v-application,
    .v-application--wrap,
    .v-main,
    .v-content,
    #one_view_form,
    .form-wrapper {
        margin: 0 !important;
        padding: 0 !important;
        min-height: auto !important;
        background: #fff !important;
        box-shadow: none !important;
        display: block !important;
        position: relative !important;
        height: auto !important;
        min-height: auto !important;
        overflow: visible !important;
    }

    html,
    body,
    #app,
    #one_view_form,
    .form-wrapper,
    .print-page {
        background: #fff !important;
        box-shadow: none !important;
    }

    .v-application{
        background:#fff !important;
    }

    .dynamic-content-wrapper {
        page-break-before: auto !important;
        page-break-after: auto !important;
        break-before: auto !important;
        break-after: auto !important;
    }

    .dynamic-content-wrapper * {
        page-break-before: auto !important;
        page-break-after: auto !important;
        break-before: auto !important;
        break-after: auto !important;
    }
}
</style>